import React from 'react';

import { IconCheck } from '@wetransfer/transfer/spaces-bundle/components/Icons/Icons';
import { Team } from '@wetransfer/transfer/hooks/useCurrentTeam/useCurrentUserTeamsQuery';
import { useCurrentUser } from '@wetransfer/transfer/hooks/useCurrentUser/useCurrentUser';
import I18n from '@wetransfer/transfer/modules/i18n';
import Helper from '@wetransfer/transfer/helper';

import './TeamItem.scss';

import ExperimentTransferListExposeTeams from '@wetransfer/transfer/constant/experiments/transfer-list-expose-teams';
import { CurrentUser } from '@wetransfer/transfer/hooks/useCurrentUser/useCurrentUserQuery';

function getMetadata(memberCount: number) {
  const showTransferListTeamsContainer =
    ExperimentTransferListExposeTeams.isExposeTeamsEnabled();

  // A user's own Pro team of one
  if (memberCount === 1) {
    return (
      <div className="TeamItem__metadata">
        <span>{I18n.t('navigation.switcher.just_you')}</span>
      </div>
    );
  }

  if (memberCount > 1)
    return (
      <div className="TeamItem__metadata">
        {!showTransferListTeamsContainer && (
          <span>{I18n.t('page.teams.title')}</span>
        )}

        <span
          dangerouslySetInnerHTML={{
            __html: I18n.t('navigation.switcher.team_member_count', {
              amountOfMembers: memberCount,
            }),
          }}
        />
      </div>
    );
}

function getTeamName(team: Team, currentUser: CurrentUser) {
  const showTransferListTeamsContainer =
    ExperimentTransferListExposeTeams.isExposeTeamsEnabled();

  return showTransferListTeamsContainer
    ? Helper.getWorkspaceName(team, currentUser)
    : team.name;
}

export interface Props {
  team: Team;
  isCurrentTeam: boolean;
}

export const TeamItem: React.FC<Props> = ({ team, isCurrentTeam }) => {
  const { members, name, logoUrl } = team;
  const { currentUser } = useCurrentUser();

  return (
    <div className="TeamItem TeamItem--active">
      <img className="TeamItem__logo" src={logoUrl} alt={name} />
      <div className="TeamItem__body">
        <p className="TeamItem__title">{getTeamName(team, currentUser)}</p>
        {getMetadata(members.length)}
      </div>
      {isCurrentTeam && (
        <div className="TeamItem__check">
          <IconCheck />
        </div>
      )}
    </div>
  );
};
